<div class="p-6 card-style-full">
  <div class="mt-4 mx-auto">

    <div class="flex w-full justify-between items-center mb-4">
      <h2 class="font-gray-700">{{ data.alert != null && data.alert ? 'Alerta - Passageiro' : 'Editar Passageiro' }}</h2>
      <button class="btn-icon" (click)="closeModal()">
        <mat-icon>close</mat-icon>
      </button>
    </div>

    @if (data.alert != null && data.alert) {
      <mat-card class="card-style gap-x-4 py-7 mb-2">
        <mat-card-content
          class="text-red-800 font-bold"
          [innerHTML]="'Faltando: <br> • ' + data.alert.split(':')[1].split(',').join('<br> •').trim()">
        </mat-card-content>
      </mat-card>
    }

    <!-- Campos base -->
    <div [formGroup]="form" class="flex flex-row flex-wrap gap-4 w-full mb-3">
      <mat-form-field class="input-tg flex-1" style="min-width:200px" appearance="outline">
        <mat-label>Nome *</mat-label>
        <input matInput formControlName="nome" />
      </mat-form-field>
      <mat-form-field class="input-tg flex-1" style="min-width:160px" appearance="outline">
        <mat-label>Documento</mat-label>
        <input matInput formControlName="documento" />
      </mat-form-field>
      <mat-form-field class="input-tg flex-1" style="min-width:160px" appearance="outline">
        <mat-label>Contato</mat-label>
        <input matInput formControlName="contato" [mask]="cellphoneMask" />
      </mat-form-field>
    </div>

    <div [formGroup]="form" class="flex flex-row flex-wrap gap-4 w-full mb-4 items-center">
      <mat-form-field class="input-tg" style="width:220px" appearance="outline">
        <mat-label>Tipo de Trecho *</mat-label>
        <mat-select formControlName="tipoTrechoId">
          @for (item of tipoTrechoList; track item.id) {
            <mat-option [value]="item.id">{{ item.descricao }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
      <mat-form-field class="input-tg" style="width:160px" appearance="outline">
        <mat-label>Data *</mat-label>
        <input matInput type="date" formControlName="data" />
      </mat-form-field>
      <mat-form-field class="input-tg" style="width:140px" appearance="outline">
        <mat-label>Hora</mat-label>
        <input matInput type="time" formControlName="hora" />
      </mat-form-field>
      <div class="flex items-center px-2 py-1">
        <mat-slide-toggle
          color="primary"
          [checked]="form.get('speaker')?.value === 'SIM'"
          (change)="form.get('speaker')?.setValue($event.checked ? 'SIM' : 'NÃO')">
          Speaker (veículo individual)
        </mat-slide-toggle>
      </div>
    </div>

    <!-- Bloco Origem -->
    @if (showOrigem) {
      <mat-card class="card-style mb-3 p-4">
        <div class="flex items-center gap-4 mb-3">
          <span class="font-bold text-gray-700">Origem</span>
          @if (toggleOrigem) {
            <mat-button-toggle-group
              [value]="origemTipo"
              (change)="setOrigemTipo($event.value)"
              appearance="legacy">
              <mat-button-toggle value="AEROPORTO">Aeroporto</mat-button-toggle>
              <mat-button-toggle value="ENDERECO">Endereço</mat-button-toggle>
            </mat-button-toggle-group>
          } @else {
            <span class="text-sm text-gray-500">{{ origemTipo === 'AEROPORTO' ? 'Aeroporto' : 'Endereço' }}</span>
          }
          @if (origemTipo) {
            <button type="button" class="btn-icon" (click)="openAddressSearch('origem')" matTooltip="Pesquisar endereço">
              <mat-icon>search</mat-icon>
            </button>
          }
        </div>
        <div [formGroup]="form">
          @if (origemTipo === 'AEROPORTO') {
            <mat-form-field class="input-tg mb-2" style="width:180px" appearance="outline">
              <mat-label>Sigla (GRU, CGH…)</mat-label>
              <input matInput formControlName="origemAeroSigla" maxlength="4" style="text-transform:uppercase" />
            </mat-form-field>
          }
          @if (origemTipo) {
            <div class="flex flex-row flex-wrap gap-3">
              <mat-form-field class="input-tg" style="width:130px" appearance="outline">
                <mat-label>CEP</mat-label>
                <input matInput mask="99999-999" formControlName="origemCep"
                  (input)="lookupCepOrigem()" (blur)="lookupCepOrigem()" />
              </mat-form-field>
              <mat-form-field class="input-tg flex-1" style="min-width:180px" appearance="outline">
                <mat-label>Logradouro</mat-label>
                <input matInput formControlName="origemLogradouro" />
              </mat-form-field>
              <mat-form-field class="input-tg" style="width:100px" appearance="outline">
                <mat-label>Número</mat-label>
                <input matInput formControlName="origemNumero" />
              </mat-form-field>
              <mat-form-field class="input-tg" style="width:150px" appearance="outline">
                <mat-label>Complemento</mat-label>
                <input matInput formControlName="origemComplemento" />
              </mat-form-field>
              <mat-form-field class="input-tg" style="width:150px" appearance="outline">
                <mat-label>Bairro</mat-label>
                <input matInput formControlName="origemBairro" />
              </mat-form-field>
              <mat-form-field class="input-tg" style="width:180px" appearance="outline">
                <mat-label>Cidade</mat-label>
                <input matInput formControlName="origemCidade" />
              </mat-form-field>
            </div>
          }
        </div>
      </mat-card>
    }

    <!-- Bloco Destino -->
    @if (showDestino) {
      <mat-card class="card-style mb-3 p-4">
        <div class="flex items-center gap-4 mb-3">
          <span class="font-bold text-gray-700">Destino</span>
          @if (toggleDestino) {
            <mat-button-toggle-group
              [value]="destinoTipo"
              (change)="setDestinoTipo($event.value)"
              appearance="legacy">
              <mat-button-toggle value="AEROPORTO">Aeroporto</mat-button-toggle>
              <mat-button-toggle value="ENDERECO">Endereço</mat-button-toggle>
            </mat-button-toggle-group>
          } @else {
            <span class="text-sm text-gray-500">{{ destinoTipo === 'AEROPORTO' ? 'Aeroporto' : 'Endereço' }}</span>
          }
          @if (destinoTipo) {
            <button type="button" class="btn-icon" (click)="openAddressSearch('destino')" matTooltip="Pesquisar endereço">
              <mat-icon>search</mat-icon>
            </button>
          }
        </div>
        <div [formGroup]="form">
          @if (destinoTipo === 'AEROPORTO') {
            <mat-form-field class="input-tg mb-2" style="width:180px" appearance="outline">
              <mat-label>Sigla (GRU, CGH…)</mat-label>
              <input matInput formControlName="destinoAeroSigla" maxlength="4" style="text-transform:uppercase" />
            </mat-form-field>
          }
          @if (destinoTipo) {
            <div class="flex flex-row flex-wrap gap-3">
              <mat-form-field class="input-tg" style="width:130px" appearance="outline">
                <mat-label>CEP</mat-label>
                <input matInput mask="99999-999" formControlName="destinoCep"
                  (input)="lookupCepDestino()" (blur)="lookupCepDestino()" />
              </mat-form-field>
              <mat-form-field class="input-tg flex-1" style="min-width:180px" appearance="outline">
                <mat-label>Logradouro</mat-label>
                <input matInput formControlName="destinoLogradouro" />
              </mat-form-field>
              <mat-form-field class="input-tg" style="width:100px" appearance="outline">
                <mat-label>Número</mat-label>
                <input matInput formControlName="destinoNumero" />
              </mat-form-field>
              <mat-form-field class="input-tg" style="width:150px" appearance="outline">
                <mat-label>Complemento</mat-label>
                <input matInput formControlName="destinoComplemento" />
              </mat-form-field>
              <mat-form-field class="input-tg" style="width:150px" appearance="outline">
                <mat-label>Bairro</mat-label>
                <input matInput formControlName="destinoBairro" />
              </mat-form-field>
              <mat-form-field class="input-tg" style="width:180px" appearance="outline">
                <mat-label>Cidade</mat-label>
                <input matInput formControlName="destinoCidade" />
              </mat-form-field>
            </div>
          }
        </div>
      </mat-card>
    }

    <!-- Bloco Aéreo -->
    @if (showAereo) {
      <mat-card class="card-style mb-3 p-4">
        <div class="font-bold text-gray-700 mb-3">Dados do Voo</div>
        <div [formGroup]="form" class="flex flex-row flex-wrap gap-3">
          <mat-form-field class="input-tg" style="width:180px" appearance="outline">
            <mat-label>Companhia</mat-label>
            <input matInput formControlName="companhia" />
          </mat-form-field>
          <mat-form-field class="input-tg" style="width:140px" appearance="outline">
            <mat-label>Nº Voo</mat-label>
            <input matInput formControlName="voo" />
          </mat-form-field>
          <mat-form-field class="input-tg" style="width:160px" appearance="outline">
            <mat-label>Data Voo</mat-label>
            <input matInput type="date" formControlName="vooData" />
          </mat-form-field>
          <mat-form-field class="input-tg" style="width:140px" appearance="outline">
            <mat-label>Hora Voo</mat-label>
            <input matInput type="time" formControlName="vooHora" />
          </mat-form-field>
        </div>
      </mat-card>
    }

    <!-- Observações (todos os tipos) -->
    <div [formGroup]="form" class="mb-4 mt-2">
      <mat-form-field class="input-tg w-full" appearance="outline">
        <mat-label>Observações</mat-label>
        <textarea matInput formControlName="observacoes" rows="2"></textarea>
      </mat-form-field>
    </div>

    <div class="flex flex-row justify-end items-end gap-5 mt-2">
      <button mat-flat-button class="btn-tg" [disabled]="form.invalid || loading" (click)="addItemToList()">
        @if (loading) {
          <mat-spinner diameter="22" class="loading-spinner"></mat-spinner>
        } @else {
          Salvar
        }
      </button>
    </div>

  </div>
</div>
